module.exports = __webpack_public_path__ + "static/media/gatech.d5470fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/assets/gatech.png
// module id = 515
// module chunks = 0